<template>
  <ui-search-input
    v-model="search"
    class="blog-filter-item__search"
    placeholder="Blog Search..."
    @enter="navigateToSearch"
    @search="navigateToSearch"
    @clear="search = ''" />
</template>

<script>
import UiSearchInput from 'Components/ui/Input/UiSearchInput.vue';
import { mapState } from 'vuex';

export default {
  name: 'BlogFilterSearch',

  components: {
    UiSearchInput,
  },

  computed: {
    ...mapState('blog', ['activeGame']),
  },

  data() {
    return {
      search: '',
    };
  },

  methods: {
    navigateToSearch() {
      this.$router.push({
        name: 'search',
        params: {
          query: `${this.search}`,
        },
        query: {
          from: 'blog',
          game: this.activeGame?.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
